import { TokenWithBalances } from 'src/common/types/models/Tokens'
import { ZERO } from 'src/common/utils/big-utils'

export const sortTokensByBalanceValue = <T extends Partial<TokenWithBalances>>(
  tokens: T[]
) => {
  return tokens.sort((a, b) => {
    // Check if tokens have price feeds
    const aHasPriceFeed = a.exchangePrice !== undefined
    const bHasPriceFeed = b.exchangePrice !== undefined

    // Get the price from price feeds or assume 0 if no feed available
    const aPrice = aHasPriceFeed ? a.exchangePrice : 0
    const bPrice = bHasPriceFeed ? b.exchangePrice : 0

    // Get balance and locked amounts, defaulting to ZERO
    const aBalance = a.balance || ZERO
    const bBalance = b.balance || ZERO
    const aLockedAmount = a.lockedAmount || ZERO
    const bLockedAmount = b.lockedAmount || ZERO

    // Calculate combined balance value (lockedAmount + balance) in USD
    const aTotalValue = aBalance.plus(aLockedAmount).mul(aPrice || ZERO)
    const bTotalValue = bBalance.plus(bLockedAmount).mul(bPrice || ZERO)

    // Sorting logic
    if (aTotalValue.gt(bTotalValue)) return -1 // Sort by highest combined value
    if (aTotalValue.lt(bTotalValue)) return 1

    // Secondary: Sort by combined token balance (balance + lockedAmount) if total values are the same
    const aCombinedBalance = aBalance.plus(aLockedAmount)
    const bCombinedBalance = bBalance.plus(bLockedAmount)

    if (aCombinedBalance.gt(bCombinedBalance)) return -1
    if (aCombinedBalance.lt(bCombinedBalance)) return 1

    // Tertiary: Tokens with price feeds should come first
    if (aHasPriceFeed && !bHasPriceFeed) return -1
    if (!aHasPriceFeed && bHasPriceFeed) return 1

    return 0 // Default case: no specific order
  })
}
